import React, { Component } from "react";

import { Button, Image, Modal } from "semantic-ui-react";

import ReimbursementDisplay from "./unauthenticated/ReimbursementDisplay";

import { hasCapability, APPROVE_REIMBURSEMENTS } from "../util/capability";

import {
  requestCloseReimbursementModal,
  performReimbursementAction
} from "../actions/reimbursements";

import { connect } from "react-redux";

class ReimbursementModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false
    };
  }

  submit = (event, value) => {
    event.stopPropagation();
    this.setState({
      submitting: value
    });
    performReimbursementAction(this.props.reimbursement, value).finally(() => {
      this.setState({
        submitting: false
      });
    });
  };

  render() {
    const props = this.props;
    const reimbursement = props.reimbursement;
    return (
      <Modal
        onClose={props.onClose}
        open={props.open}
        closeIcon={true}
        centered={false}
      >
        <Modal.Header>{reimbursement.description}</Modal.Header>
        <Modal.Content image scrolling>
          <style>{`
			  		.heightFix, .heightFix > img {
			  			margin-bottom: 1em;
			  		}
			  	`}</style>
          <Image
            wrapped
            size="large"
            src={reimbursement.image}
            className="heightFix"
          />
          <Modal.Description>
            <div style={{ marginBottom: "1em" }}>
              <ReimbursementDisplay reimbursement={reimbursement} />
            </div>
          </Modal.Description>
        </Modal.Content>
        {hasCapability(APPROVE_REIMBURSEMENTS) && (
          <Modal.Actions>
            {reimbursement.status === "submitted" && (
              <div>
                <Button
                  labelPosition="right"
                  icon="check"
                  content="Approve"
                  positive
                  disabled={!!this.state.submitting}
                  loading={this.state.submitting === "approve"}
                  onClick={e => this.submit(e, "approve")}
                />
                <Button
                  labelPosition="right"
                  icon="times"
                  content="Reject"
                  negative
                  disabled={!!this.state.submitting}
                  loading={this.state.submitting === "reject"}
                  onClick={e => this.submit(e, "reject")}
                />
              </div>
            )}
            {reimbursement.status === "approved" && (
              <div>
                <Button
                  labelPosition="right"
                  icon="times"
                  content="Undo approval"
                  disabled={!!this.state.submitting}
                  loading={this.state.submitting === "unapprove"}
                  onClick={e => this.submit(e, "unapprove")}
                />
              </div>
            )}
            {reimbursement.status === "rejected" && (
              <div>
                <Button
                  labelPosition="right"
                  icon="times"
                  content="Undo rejection"
                  disabled={!!this.state.submitting}
                  loading={this.state.submitting === "unreject"}
                  onClick={e => this.submit(e, "unreject")}
                />
              </div>
            )}
            {reimbursement.status === "paid" && (
              <div>
                <div style={{ float: "right", marginBottom: "1em" }}>
                  This reimbursement has been paid out.
                </div>
              </div>
            )}
          </Modal.Actions>
        )}
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(requestCloseReimbursementModal())
});

export default connect(
  null,
  mapDispatchToProps
)(ReimbursementModal);



// WEBPACK FOOTER //
// ./frontend/src/components/ReimbursementModal.js